import { usePermissionStore } from 'stores';

export const SESSION_PERMISSIONS = Object.freeze({
  READ: 'session.read',
  CREATE: 'session.create',
  UPDATE: 'session.update',
  DELETE: 'session.delete',
  ATTENDANCE_UPDATE: 'session.attendance.update',
  EVIDENCE_UPLOAD: 'session.evidence.upload',
  EVIDENCE_DELETE: 'session.evidence.delete',
  REPORT_READ: 'session.report.read',
});

const matches = (permissionKey, requiredKey) => {
  if (!permissionKey) return false;
  if (permissionKey === '*') return true;
  if (permissionKey === requiredKey) return true;
  if (permissionKey.endsWith('.*')) {
    const prefix = permissionKey.slice(0, -2);
    return requiredKey === prefix || requiredKey.startsWith(`${prefix}.`);
  }
  return false;
};

/**
 * Read-only check against the current user's permissions.
 *
 * @param {string} requiredKey  Permission key (e.g. 'session.create').
 *                              Supports server-issued wildcards: '*' and 'session.*'.
 * @returns {boolean}
 */
export const useHasPermission = requiredKey => {
  const permissions = usePermissionStore(state => state.permissions);
  if (!requiredKey) return false;
  return permissions.some(p => p.assigned === true && matches(p.key, requiredKey));
};

/**
 * Same logic as useHasPermission, but operates on an already-resolved permission array
 * (useful outside React components / inside selectors).
 */
export const checkPermission = (permissions, requiredKey) => {
  if (!permissions || !requiredKey) return false;
  return permissions.some(p => p.assigned === true && matches(p.key, requiredKey));
};
